import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "map-info" }
const _hoisted_2 = {
  key: 0,
  class: "map-inf__text"
}
const _hoisted_3 = {
  key: 1,
  class: "map-info__variable-description"
}
const _hoisted_4 = { class: "map-info__info-title map-inf__text" }
const _hoisted_5 = { class: "map-inf__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.variableDescription)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.variableDescription), 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: JSON.stringify(item) + index,
        class: "map-info__info-item-wrapper"
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(item.title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(item.text), 1)
      ]))
    }), 128))
  ]))
}